/**
 * Control-specific style utilities for form elements and interactive components.
 * These styles use CSS variables defined in the theme for consistent sizing
 * and spacing across all control elements.
 *
 * Text sizes follow the relationships defined in theme.css:
 * sm: --control-text-sm (maps to --text-xs)
 * md: --control-text-md (maps to --text-sm)
 * lg: --control-text-lg (maps to --text-base)
 * xl: --control-text-xl (maps to --text-lg)
 */

export type Size = "sm" | "md" | "lg" | "xl";

export const controlStyles = {
  sm: {
    text: "text-[length:var(--control-text-sm)]",
    height: "h-[var(--control-sm-height)]",
    padding: "px-[var(--control-padding-sm)]",
    paddingY: "py-[var(--control-gap-sm)]",
    gap: "gap-[var(--control-gap-sm)]",
  },
  md: {
    text: "text-[length:var(--control-text-md)]",
    height: "h-[var(--control-md-height)]",
    padding: "px-[var(--control-padding-md)]",
    paddingY: "py-[var(--control-gap-md)]",
    gap: "gap-[var(--control-gap-md)]",
  },
  lg: {
    text: "text-[length:var(--control-text-lg)]",
    height: "h-[var(--control-lg-height)]",
    padding: "px-[var(--control-padding-lg)]",
    paddingY: "py-[var(--control-gap-lg)]",
    gap: "gap-[var(--control-gap-lg)]",
  },
  xl: {
    text: "text-[length:var(--control-text-xl)]",
    height: "h-[var(--control-xl-height)]",
    padding: "px-[var(--control-padding-xl)]",
    paddingY: "py-[var(--control-gap-xl)]",
    gap: "gap-[var(--control-gap-xl)]",
  },
} as const;
